export const REVIEW_CUTOFF_DAYS = 30
